import { ReactElement } from 'react'
import { RespondToTheMeeting } from '../../pages/Calendar/types'

export enum ActivityStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive'
}

export type TIconNameItem = {
  firstName: string
  lastName: string
  src: string | null
  roleName: string
  className?: string
  highlightedText?: string
  status?: RespondToTheMeeting | null
  tagText?: string
  email?: string
  organization?: string
  facilityName?: string
}

export type StatusIconProps = {
  children: ReactElement
  status?: RespondToTheMeeting | ActivityStatus | null
  avatarSize?: number
}
